export default __webpack_public_path__ + "static/045-7d460dc9b1638ac4f1f64b52b56b0b22.jpg";